import { history } from "./RouterStore";
import externalInterfaceStore from "./ExternalInterfaceStore";
import { stringify } from "query-string";

export class RouterData {
    queryParams?: any;
    get queryString() {
        return this.queryParams ? stringify(this.queryParams) : "";
    }
}

export const routerData = new RouterData();

const getTarget = (route: string, omitQueryString?: boolean) => routerData.queryString && !omitQueryString ? `${route}?${routerData.queryString}` : route;

// Has to live here to avoid circular dependencies
export function pushRoute(route: string, omitQueryString?: boolean) {
    const target = getTarget(route, omitQueryString);
    if (route !== history.location.pathname) {
        return history.push(target);
    } else {
        // This happens e.g. when removing the access token from the URL
        return history.replace(target);
    }
}

export function replaceRoute(route: string, omitQueryString?: boolean) {
    const target = getTarget(route, omitQueryString);
    return history.replace(target);
}


// WEBPACK FOOTER //
// ./src/stores/RouterFunctions.ts